export default function NoInsights({
  message = "No insights available for the chosen filters.",
  height = "h-full",
}) {
  return (
    <div className={`flex justify-center items-center ${height}`}>
      <p className="font-medium text-gray-500">{message}</p>
    </div>
  );
}
